/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useEffect, useRef, useState, useContext } from 'react';
import InfoComponent from '../project/InfoComponent';
import { GridAlgorithm, MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import styleConfigHelper from '../helper/styleConfigHelper';
import mapConfigHelper from '../helper/mapConfigHelper';
import messageEnums from '../helper/messageEnums';
import applicationMode from '../helper/applicationMode';
import { MapContext } from './MapContextProvider';
import appModes from '../helper/appModes';
// import { SupplierService } from '../firebase/SupplierService';
// import workspaceHelper from '../helper/workspaceHelper';

let infoWindow, geocoder, dataInputTime;
let supplierService = null;

/*global google*/
export default function Marker({ mapOptions }) {
    const { map, mapData, setMapData, setMessages, resetMessages, mapWorkspace } = useContext(MapContext);

    const [selectedItem, setSelectedItem] = useState();
    const [featureList, setFeatureList] = useState([]);
    const [mapBounds, setMapBounds] = useState();
    const previousValue = useRef(false);

    const [isCluster, setIsCluster] = useState();
    const [clusterGroup, setClusterGroup] = useState();
    const [markerCluster, setMarkerCluster] = useState();
    const infoCardRef = useRef();

    const symbolConfig = new styleConfigHelper();
    const mapHelper = new mapConfigHelper(mapOptions);
    // const workHelper = new workspaceHelper();

    const { InfoWindowEnabled, ApplicationMode } = appModes(mapOptions);

    useEffect(() => {
        if (InfoWindowEnabled) {
            infoWindow = new google.maps.InfoWindow({
                content: infoCardRef.current,
                disableAutoPan: true
            });

            infoWindow.open({ map: map });

            google.maps.event.addListener(map, 'click', () => {
                if (infoWindow) {
                    infoWindow.close();
                }
            });
        }
        geocoder = new google.maps.Geocoder();
        // if (!supplierService) supplierService = new SupplierService();
        // getSupplierList();
    }, []);

    useEffect(() => {
        if (map) {
            dataInputTime = performance.now();
            createMarker(mapData, dataInputTime);
        }
    }, [mapData, isCluster, clusterGroup]);

    useEffect(() => {
        removeMarker(previousValue.current);
        previousValue.current = featureList;
        // setMarkers(featureList);
        if (map) {
            addMarkertoMap(featureList);
        }
    }, [featureList]);

    useEffect(() => {
        if (mapOptions) {
            if (ApplicationMode == applicationMode.default || ApplicationMode == applicationMode.custom) {
                const setcluster = mapOptions.IsCluster ? true : false;
                setIsCluster(setcluster);
                setClusterGroup(mapOptions.ClusterBy);
            }
        }
    }, [mapOptions]);

    // const getSupplierList = () => {
    //     return supplierService.getSupplierList((item, key) => {
    //         setMapData(item);
    //     });
    // };

    const removeMarker = (list) => {
        // let _start = performance.now();

        if (!Array.isArray(list)) return;

        list?.forEach((element) => {
            element.setMap(null);
        });

        markerCluster?.forEach(function (item) {
            item.clearMarkers(true);
        });

        // console.log("Time Taken for Drawing --> " + (performance.now() - _start));
    };

    const hasOwnProperty = (object, value) => {
        return Object.prototype.hasOwnProperty.call(object, value);
    };

    const addNotification = (messageList, messageType, index) => {
        if (!hasOwnProperty(messageList, messageType.name)) messageList[messageType.name] = [];

        let indexItem = messageList[messageType.name].findIndex((a) => a == index);
        if (indexItem == -1) {
            messageList[messageType.name].push(index);
            // setMessages({ ...messages });
        }

        return messageList;
    };

    const checkMissingProperties = (project, index, messageList) => {
        let status = false;
        let tmpMessageList = messageList;

        if (!project || Object.keys(project).length === 0) {
            return [tmpMessageList, status];
        }

        if (
            !hasOwnProperty(project, 'address') &&
            (!hasOwnProperty(project, 'latitude') || !hasOwnProperty(project, 'longitude'))
        ) {
            tmpMessageList = addNotification(tmpMessageList, messageEnums.addressNotProvided, index);
            return [tmpMessageList, status];
        }

        status = true;

        return [tmpMessageList, status];
    };

    async function createMarker(listMarker, time) {
        let messageList = resetMessages();

        let markerList = [];
        let markerStatus = false;

        if (!listMarker) {
            setFeatureList(markerList);
            return;
        }
        const bounds = new google.maps.LatLngBounds();

        let requestList = listMarker?.map((item, index) => {
            let myPromise, marker;

            [messageList, markerStatus] = checkMissingProperties(item, index, messageList);
            if (!markerStatus) return;

            let geocodeSucceed = false;

            if (item.latitude && item.longitude) {
                const pos = new google.maps.LatLng(item.latitude, item.longitude);
                if (!pos.lat() || !pos.lng()) {
                    messageList = addNotification(messageList, messageEnums.couldNotGeolocated, index);
                    return null;
                }
                marker = createMarkerforMap(item, bounds, pos);
                markerList.push(marker);
                geocodeSucceed = true;
                messageList = addNotification(messageList, messageEnums.geolocationSucceed, index);
                return pos;
            }

            if (item.FullAddress && !geocodeSucceed) {
                myPromise = new Promise((resolve) => {
                    return googleGeocode(item.FullAddress, resolve);
                });

                myPromise.then((value) => {
                    if (value) {
                        item.latitude = value.lat();
                        item.longitude = value.lng()
                        marker = createMarkerforMap(item, bounds, value);
                        markerList.push(marker);
                        messageList = addNotification(messageList, messageEnums.geocodeSucceed, index);
                    } else {
                        messageList = addNotification(messageList, messageEnums.couldNotGeolocated, index);
                    }
                });
            }

            return myPromise;
        });

        // return Promise.all(requestList);

        //start drawing after all request finished
        return Promise.all(requestList).then(() => {
            if (dataInputTime == time) {
                setMapBounds(bounds);
                setFeatureList(markerList);
                setMessages({ ...messageList });
            }
        });
    }

    const addMarkertoMap = (markerList) => {
        let isLocated = false;

        //todo check
        if (!mapWorkspace) {
            if (!markerList || markerList.length == 0) {
                map.setCenter(mapHelper.getMapCenter());
                map.setZoom(mapHelper.getZoom());
                return;
            }
        }

        if (isCluster) addClusterMarkers(markerList);
        else {
            markerList.forEach((element) => {
                element.setMap(map);
            });
        }

        //todo check
        if (!mapWorkspace) {
            if (markerList.length > 1) {
                let parentTab = document.getElementById('oemGisMap').parentElement;
                if (mapBounds && parentTab.checkVisibility()) {
                    isLocated = true;
                    map.fitBounds(mapBounds);
                }
            }

            if (markerList.length == 1 && !isLocated) {
                map.panTo(markerList[0].position);
                map.setCenter(markerList[0].position.toJSON());
                isLocated = true;
            }

            if (!isLocated) {
                map.setCenter(mapHelper.getMapCenter());
                map.setZoom(mapHelper.getZoom());
            }
        }
    };

    const createMarkerforMap = (item, bounds, position) => {
        let order = 999;
        let tmpIcon = null;
        if (ApplicationMode == applicationMode.default || ApplicationMode == applicationMode.custom) {
            [tmpIcon, order] = createIcon(item);
        }

        const marker = new google.maps.Marker({
            icon: tmpIcon,
            // label: item.Code,
            item: item,
            zIndex : 0,
            // zIndex: Number(google.maps.Marker.MAX_ZINDEX - 1000 - order)
        });

        // if (!isCluster)
        //   marker.setMap(map)

        marker.setPosition(position);
        bounds.extend(position);

        marker.addListener('dblclick', (e) => {
            e.stop();
            map.setCenter(marker.position);
            smoothZoom(map, 18, map.getZoom()); // call smoothZoom, parameters map, final zoomLevel, and starting zoom level
        });

        if (InfoWindowEnabled) {
            marker.addListener('click', () => {
                setSelectedItem(item);
                infoWindow.open({
                    anchor: marker,
                    map,
                    shouldFocus: false
                });
            });
        }

        return marker;
    };

    // add the markers to the map, using point clustering
    const addClusterMarkers = (markers) => {
        let markerListArray = [];

        let objList = mapHelper.getClusterGroupArray(markers, clusterGroup);

        objList?.map((item) => {
            const clusterOpt = {
                map: map,
                markers: item.Markers,
                renderer: renderOption
            };

            if (mapOptions) {
                if (hasOwnProperty(mapOptions, 'ClusterAlgorithm')) {
                    let size = 100;
                    let maxZoom = 13;

                    if (hasOwnProperty(mapOptions, 'ClusterSize')) size = mapOptions.ClusterSize;

                    if (hasOwnProperty(mapOptions, 'ClusterMaxZoom')) maxZoom = mapOptions.ClusterMaxZoom;

                    if (mapOptions.ClusterAlgorithm == 'GridAlgorithm') {
                        size = size != null ? size : 30;
                        clusterOpt['algorithm'] = new GridAlgorithm({ gridSize: 100, maxZoom: 25 });
                    } else if (mapOptions.ClusterAlgorithm == 'SuperClusterAlgorithm') {
                        clusterOpt['algorithm'] = new SuperClusterAlgorithm({ radius: size, maxZoom: maxZoom });
                    }
                }
            }
            let tmp = new MarkerClusterer(clusterOpt);
            markerListArray.push(tmp);
        });

        setMarkerCluster(markerListArray);
    };

    const renderOption = {
        render({ count, position, markers }) {
            // change color if this cluster has more markers than the mean cluster
            // let color = count > Math.max(10, stats.clusters.markers.mean) ? "#256D85" : "#007EB6";
            // color = "#007EB6";
            let clusterBy = markers[0].item[clusterGroup];

            let symbolConf = symbolConfig.getColourForCluster(markers[0].item[clusterGroup]);
            let title = `Click to expand cluster`;
            title += clusterBy ? ` (${clusterBy})` : ``;

            let xVal = count > 10 ? 85 : 100;
            // create svg url with fill color
            const svg = `<?xml version="1.0"?> \
       <svg fill="${symbolConf.FillCol}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"> \
          <g> \
            <circle cx="120" cy="120" opacity=".9" r="70" /> \
            <circle cx="120" cy="120" opacity=".6" r="90" /> \
            <circle cx="120" cy="120" opacity=".3" r="110" /> \
          <text x="${xVal}" y="140" font-size="60" font-weight="${symbolConfig.defaultFont.fontWeight}" font-family="${symbolConfig.defaultFont.fontFamily
                }" fill="rgba(0,0,0,1)">${String(count)}</text> \
            </g> \
          </svg>`;


            // create marker using svg icon
            const marker = new google.maps.Marker({
                position,
                icon: {
                    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
                    scaledSize: new google.maps.Size(50, 50),
                    anchor: new google.maps.Point(30, 5),
                    origin: new google.maps.Point(0, 0)
                },
                // label: {
                //   text: String(count),
                //   color: "rgba(0,0,0,1)",
                //   // fontSize: "13",
                //   // fontFamily: "Monospace",
                //   // TODO: Use the config..
                //   fontSize: symbolConfig.defaultFont.fontSize,
                //   fontFamily: symbolConfig.defaultFont.fontFamily,
                // },
                title: title,
                // adjust zIndex to be above other markers
                zIndex: Number(google.maps.Marker.MAX_ZINDEX - symbolConf.DrawSort-100)
            });

            if (InfoWindowEnabled) {
                marker.addListener('click', () => {
                    if (infoWindow) {
                        infoWindow.close();
                    }
                });
            }
            return marker;
        }
    };

    async function googleGeocode(address, resolve) {
        resolve(null);
        return;
        return await geocoder
            .geocode({ address: address })
            .then((result) => {
                const location = result.results[0].geometry.location;
                resolve(location);
                return location;
            })
            .catch((e) => {
                resolve(null);
                console.log('Geocode was not successful for the following reason: ' + e);
                return null;
            });
    }

    function createIcon(item) {
        const symObj = symbolConfig.getColourData(item.Discriminator);
        if (!symObj) {
            console.error('symObj is null for status value:');
            console.log(item);
            return null;
        }
        const borderType = symObj.HasDash ? "stroke-dasharray='3 1'" : '';
        const svg = `<?xml version="1.0"?> \
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg"> \
        <g> \
          <rect x="1" y="1" rx="8" ry="8" width="75" height="18" ${borderType} style="fill:${symObj.FillCol};stroke:${symObj.OutlineCol};stroke-width:2.0;opacity:1;" /> \
          <text x="10" y="13.9" font-size="${symbolConfig.defaultFont.fontSize}" font-weight="${symbolConfig.defaultFont.fontWeight}" font-family="${symbolConfig.defaultFont.fontFamily}" fill="${symObj.TextCol}">${item.vendorNo}</text> \
        </g> \
      </svg>`;

        const svg2 = `<? xml version = "1.0" encoding = "iso-8859-1" ?>\
      <svg height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns: xlink="http://www.w3.org/1999/xlink" \ 
      viewBox="0 0 293.334 293.334" xml: space="preserve"> <g> <g> \ 
      <path style="fill:#010002;" d="M146.667,0C94.903,0,52.946,41.957,52.946,93.721c0,22.322,7.849,42.789,20.891,58.878 \ 
      c4.204,5.178,11.237,13.331,14.903,18.906c21.109,32.069,48.19,78.643,56.082,116.864c1.354,6.527,2.986,6.641,4.743,0.212 \ 
      c5.629-20.609,20.228-65.639,50.377-112.757c3.595-5.619,10.884-13.483,15.409-18.379c6.554-7.098,12.009-15.224,16.154-24.084 \ 
      c5.651-12.086,8.882-25.466,8.882-39.629C240.387,41.962,198.43,0,146.667,0z M146.667,144.358 \ 
      c-28.892,0-52.313-23.421-52.313-52.313c0-28.887,23.421-52.307,52.313-52.307s52.313,23.421,52.313,52.307 \ 
      C198.98,120.938,175.559,144.358,146.667,144.358z"/> \ 
      <circle style="fill:#010002;" cx="146.667" cy="90.196" r="21.756" />  </g> </g> </svg>`;

        return [
            {
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
                anchor: new google.maps.Point(30, 5),
                origin: new google.maps.Point(0, 0),
                size: new google.maps.Size(120, 21)
            },
            symObj.DrawSort
        ];
    }

    // the smooth zoom function
    function smoothZoom(map, max, cnt) {
        if (cnt >= max) {
            return;
        } else {
            let z = google.maps.event.addListener(map, 'zoom_changed', function () {
                google.maps.event.removeListener(z);
                smoothZoom(map, max, cnt + 1);
            });
            setTimeout(function () {
                map.setZoom(cnt);
            }, 50);
        }
    }

    return (
        <>
            <div>{InfoWindowEnabled && <InfoComponent item={selectedItem} ref={infoCardRef} />}</div>
        </>
    );
}
